import React, { createContext, ReactNode, useContext } from 'react'
import { BottomSliderModalProps } from './typings'

const Context = createContext<BottomSliderModalProps | null>(null)

export const useBottomSliderModalContext = () => {
  const context = useContext(Context)

  if (!context) {
    throw new Error('Missing BottomSliderModalProvider')
  }

  return context
}

type Props = {
  children?: ReactNode
} & BottomSliderModalProps

export const BottomSliderModalProvider = ({ children, ...props }: Props) => (
  <Context.Provider value={props}>{children}</Context.Provider>
)
